export { default } from './LessonDetails';



// WEBPACK FOOTER //
// ./src/pages/Students/DataCentre/LessonDetails/index.ts